/**
 * Apply dynamic branding and theme CSS variables on app boot and updates.
 *
 * @param {Object} branding
 * @param {string} [branding.appName]
 * @param {string} [branding.logoUrl]
 * @param {string} [branding.primaryColor]
 * @param {string} [branding.secondaryColor]
 * @param {string} [branding.favicon]
 * @param {string} [branding.faviconUrl]
 */
export function applyDynamicBranding(branding = {}) {
  if (typeof document === 'undefined') return;

  const root = document.documentElement;

  // 1. Dynamic CSS variables
  const primary = branding.primaryColor;
  const secondary = branding.secondaryColor;

  if (primary) {
    root.style.setProperty('--primary-color', primary);
    const hex = primary.replace('#', '');
    if (hex.length === 6) {
      const num = parseInt(hex, 16);
      if (!isNaN(num)) {
        const r = (num >> 16) & 255;
        const g = (num >> 8) & 255;
        const b = num & 255;
        root.style.setProperty('--primary-color-rgb', `${r}, ${g}, ${b}`);
      }
    }
  }

  if (secondary) {
    root.style.setProperty('--secondary-color', secondary);
    root.style.setProperty('--primary-dark', secondary);
  }

  // 2. Browser Tab Title
  if (branding.appName) {
    document.title = `${branding.appName} | Property Management System`;
  }

  // 3. Dynamic Favicon & Icons
  const favicon = branding.favicon || branding.faviconUrl;
  if (favicon) {
    const selectors = [
      'link[rel="icon"]',
      'link[rel="shortcut icon"]',
      'link[rel="apple-touch-icon"]'
    ];
    selectors.forEach((sel) => {
      document.querySelectorAll(sel).forEach((el) => {
        el.setAttribute('href', favicon);
      });
    });
  }
}

export default applyDynamicBranding;
